<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15.2759 17.0897L12 13.65L8.72414 17.0897C8.34325 17.4896 7.71028 17.505 7.31035 17.1241C6.91041 16.7433 6.89498 16.1103 7.27586 15.7103L10.619 12.2L7.27586 8.68966C6.89498 8.28972 6.91041 7.65675 7.31034 7.27586C7.71028 6.89498 8.34325 6.91041 8.72414 7.31034L12 10.75L15.2759 7.31034C15.6567 6.91041 16.2897 6.89498 16.6897 7.27586C17.0896 7.65675 17.105 8.28972 16.7241 8.68966L13.381 12.2L16.7241 15.7103C17.105 16.1103 17.0896 16.7433 16.6897 17.1241C16.2897 17.505 15.6567 17.4896 15.2759 17.0897Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'ClearIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
